<template>
    <thead
        class="uik-table-head"
        :class="{'uik-table-head--sticky': sticky}"
    >
        <tr class="uik-table-row">
            <UikTh
                v-if="selectedItems"
                class="uik-table-head-cell__checkbox"
                align="center"
                width="10"
            >
                <UikCheckbox
                    tabindex="0"
                    :value="areAllSelected"
                    @click.native.prevent="toggleSelected()"
                />
            </UikTh>
            <slot/>
        </tr>
    </thead>
</template>

<script>
import UikTh from "./Th"

export default {
    name: "UikTHead",
    components: { UikTh },
    inject: ["selectedItems", "selectOptions"],
    props: {
        /**
         * Is component sticky
         */
        sticky: { type: Boolean, default: true }
    },
    computed: {
        /**
         * Computes wether all the rows in the table are selected
         *
         * @return {Boolean}
         */
        areAllSelected () {
            if (this.selectOptions.length > 0) {
                for (let i = 0; i < this.selectOptions.length; i++) {
                    let option = this.selectOptions[i]
                    if (!this.selectedItems.includes(option)) return false
                }
                return true
            }
            return false
        }
    },
    methods: {
        /**
         * Toggles the selected state of all rows in the table
         */
        toggleSelected () {
            if (!this.areAllSelected) {
                let selected = []
                for (let i = 0; i < this.selectOptions.length; i++) {
                    const option = this.selectOptions[i]
                    if (!this.selectedItems.includes(option)) {
                        this.selectedItems.push(option)
                        selected.push(option)
                    }
                }
                this.$emit("selected", selected)
            } else {
                let unselected = []
                for (let i = this.selectOptions.length - 1; i >= 0; i--) {
                    const option = this.selectOptions[i]
                    const index = this.selectedItems.indexOf(option)
                    if (index > -1) {
                        this.selectedItems.splice(index, 1)
                        unselected.push(option)
                    }
                }
                this.$emit("unselected", unselected)
            }
            this.$emit("select", this.selectedItems)
        }
    }
}
</script>
